import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { ClicksDataService, ClicksColumnsService } from '../../../services';
import { Click, ClicksResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-click-details',
  templateUrl: './click-details.component.html',
  styleUrls: ['./click-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ClickDetailsComponent implements OnInit, OnDestroy {

  public click: Click = {};
  public clicks: Click[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private clicksDataService: ClicksDataService,
    private clicksColumnsService: ClicksColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Click - Details');
        this.getClick(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.click !== 'undefined') {
      this.click = this.dynamicDialogConfig.data.click;
    }
    this.columns = this.clicksColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getClick(id: number): void {
    this.isLoading = true;
    this.clicksDataService.getClick(id).subscribe((response: Click|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.click = response;
      }
    });
  }

  list() {
    this.router.navigate(['/clicks']);
  }

  add() {
    this.router.navigate(['/clicks/add']);
  }

  edit() {
    this.router.navigate(['/clicks/edit/' + this.click.id]);
  }

}
@Component({
  selector: 'app-click-details',
  templateUrl: './click-details.component.html',
  styleUrls: ['./click-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogClickDetailsComponent extends ClickDetailsComponent {
}

